import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage101 from "../../../../assets/PDFViewerImages/PDFViewerImage101.jpg";
import PDFViewerImage102 from "../../../../assets/PDFViewerImages/PDFViewerImage102.jpg";


const Chapter25 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>
                 {/* Chapter 25 */}
                <section id="section25" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter25Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph1}

                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter25Paragraph2}
                    </p>

                    <ol className="drivers-handbook-list">
                        <li>{language. chapter25List11}</li>
                        <li>
                           {language. chapter25List12}

                        </li>
                        <li>{language. chapter25List13}</li>
                        <li>{language. chapter25List14}</li>
                        <li>{language. chapter25List15}
                        </li>
                    </ol>

                    <div className="image-box">
                        <img src={PDFViewerImage101} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                         {language.chapter25Paragraph3}

                    </p>

                    <ol className="drivers-handbook-list">
                        <li>{language.chapter25List21}</li>
                        <li>{language.chapter25List22}</li>
                        <li>{language.chapter25List23}</li>
                         <li>{language.chapter25List24}</li>
                    </ol>

                    <div className="image-box">
                        <img src={PDFViewerImage102} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading1}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph4}
                    </p>
                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading2}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph5}

                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading3}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                          {language.chapter25Paragraph6}

                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading4}

                    </h3>
                    <p className="drivers-handbook-paragraph">
                          {language.chapter25Paragraph7}</p>

                        <br></br>
                        <br></br>

                       <p className="drivers-handbook-paragraph">
                          {language.chapter25Paragraph8b}</p>

                        <br></br>
                        <br></br>
                        <p className="drivers-handbook-paragraph">
                          {language.chapter25Paragraph9b}
                    </p>

                    <ul className="drivers-handbook-list">
                         <li>{language.chapter25List31}</li>
                         <li>{language.chapter25List32}</li>
                         <li>{language.chapter25List33}</li>
                         <li>{language.chapter25List34}</li>
                          <li>{language.chapter25List35}</li>
                          <li>{language.chapter25List36}</li>
                          <li>{language.chapter25List37}</li>
                          <li>{language.chapter25List38}</li>
                        

                    </ul>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading5}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph8}

                    </p>
                    <ul className="drivers-handbook-list">
                         <li>{language.chapter25List41}</li>
                         <li>{language.chapter25List42}</li>
                         <li>{language.chapter25List43}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter25Subheading6}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter25Paragraph9}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph10}

                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter25Paragraph11}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter25Paragraph12}
                    </p>


                </section>


        </>
    )

}

export default Chapter25;
